module.exports = __webpack_public_path__ + "static/img/son9.6b65dc8c.png";